"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG_SCHEMA_VALUE_OPTION = void 0;
exports.TAG_SCHEMA_VALUE_OPTION = {
    value: "'TA0009'",
    label: "'Collection'",
    link: "'https://attack.mitre.org/tactics/TA0009'",
};
